module.exports = __webpack_public_path__ + "assets/img/05-l.51301ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/05-l.jpg
// module id = Ke2r
// module chunks = 0